if (typeof ProductTabsWidget !== 'function') {

  class ProductTabsWidget extends HTMLElement {

    constructor() {
      super();
      this.navItems = Array.from(this.querySelectorAll('[data-tab-index]'));
      this.panels = Array.from(this.querySelectorAll('.product-tabs__panel'));

      this.navItems.forEach(navItem => {
        navItem.addEventListener('click', () => this.selectTab(navItem.getAttribute('data-tab-index')));
      });
    }

    selectTab(index) {
      this.navItems.forEach(navItem => {
        const isActive = navItem.getAttribute('data-tab-index') === index;
        navItem.classList.toggle('is-active', isActive);
        navItem.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach(panel => {
        const isActive = panel.getAttribute('data-tab-index') === index;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

  }

  if (typeof customElements.get('product-tabs-widget') === 'undefined') {
    customElements.define('product-tabs-widget', ProductTabsWidget);
  }

}
